import TextField, { OutlinedTextFieldProps } from "@mui/material/TextField";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { Field, getIn } from "formik";

const useStyles = makeStyles(() =>
  createStyles({
    input: { maxWidth: "100%", width: "100%" },
  }),
);
type TextInputProps = Omit<OutlinedTextFieldProps, "variant">;
export function TextInputForMultiInput(props: TextInputProps) {
  const classes = useStyles();
  return (
    <Field name={props.name}>
      {({ field, form, meta }: { field: any; form: any; meta: any }) => (
        <TextField
          {...field}
          {...props}
          className={`${classes.input} ${props.className}`}
          error={
            !!(meta.error || props.error || getIn(form.status, field.name))
          }
          helperText={
            meta.error || props.helperText || getIn(form.status, field.name)
          }
          onBlur={() => null}
          onChange={() => null}
          value={field.value ?? ""}
          variant="outlined"
        />
      )}
    </Field>
  );
}
